// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"abc1ff6d","359":"8c539160","568":"63629700","844":"c1afd65c"}[chunkId] + ".chunk.js";
};